__turbopack_context__.v({
  "bioContainer": "yhgx8a_bioContainer",
  "bioContent": "yhgx8a_bioContent",
  "bioTitle": "yhgx8a_bioTitle",
  "editView": "yhgx8a_editView",
  "missingData": "yhgx8a_missingData",
  "missingDataHeader": "yhgx8a_missingDataHeader",
  "root": "yhgx8a_root",
});
